<template>
  <div style="height: 100%" class="so-blue so-center" ref="container" v-on:click="containerClicked">
    <div class="more-yao-button"
         id="more-yao-button"
         v-on:click="moreClicked"></div>
  </div>
</template>

<script>
  import Bubble from './Bubble.vue';
  import Vue from 'vue';
  const $ = require('jquery');
  let BubbleClass = Vue.extend(Bubble);

  export default {
    name: 'BubbleHolder',
    components: { Bubble },
    data() {
        return {
            msg: "New Phil, who dis?",
            count: 1,
            paused: false,
            bubbles: []
        }
    },
    methods: {
        moreClicked() {
            console.log('More clicked.');
            this.addBubbleToDOM();
        },
        containerClicked(event) {
            console.log('Container clicked.');
            if(event.target.className !== 'more-yao-button') this.paused ^= true;
        },
        checkCollisions() {
            let screenHeight = $(window).height();
            let screenWidth = $(window).width();
            let collision = false;

            for(let i = 0; i < this.bubbles.length; i++) {
                let b = this.bubbles[i];
                let pos = $(b.id).position();
                let x1 = pos.left;
                let x2 = pos.left + 100;
                let y1 = pos.top;
                let y2 = pos.top + 100;
                if( y1 < 0 || y2 > screenHeight) { b.yVel = b.yVel * -1; collision = true;}
                if( x1 < 0 || x2 > screenWidth ) { b.xVel = b.xVel * -1; collision = true;}
                if(collision) {
                    console.log(pos);
                    console.log({screenHeight, screenWidth})
                }
            }
        },
        addBubbleToDOM(xVel, yVel) {
          if(xVel === undefined || yVel === undefined) {
              xVel = Math.floor(3*Math.random()) + 1;
              yVel = Math.floor(3*Math.random()) + 1;
          }
          let image_num = Math.floor(this.images.length*Math.random());
          let bub = new BubbleClass({ propsData: {image: this.images[image_num]} });
          bub.$mount();
          let bubble_element = this.$refs.container.appendChild(bub.$el);
          let next_id = this.bubbles.length + 1;
          bubble_element.setAttribute("id", "bubble_" + next_id.toString());
          this.bubbles.push({id: '#bubble_' + next_id.toString(), xVel, yVel});
        },
        run() {
          let pos;
          if(!this.paused) {
            for (let i = 0; i < this.bubbles.length; i++) {
                let b = this.bubbles[i];
                pos = $(b.id).position();
                $(b.id).offset({top: pos.top + b.yVel, left: pos.left + b.xVel});
            }
            this.checkCollisions();
          }
        }
    },
    created: function () {
        this.images = [];
        for(let x = 1; x < 25; x++) {
            this.images.push(
                require('../assets/phils/' + x.toString() + '.png')
            )
        }
    },
    mounted: function() {
        this.addBubbleToDOM(1,1);
        setInterval(this.run, 6);
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.so-blue {
  color: dodgerblue;
}

.so-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.more-yao-button {
  height: 100px;
  width: 100px;
  border-radius: 100%;
  background-image: url('../assets/more_yao_button.png');
  box-shadow: 0 0 4px rgba(0,0,0,.14), 0 4px 8px rgba(0,0,0,.28);
  background-size: cover;
  background-position: center;
}

.more-yao-button:active {
  opacity: 0.85;
  margin-top: 5px;
}

</style>
